import { canSyncNow } from "./runtime";
import { listMutations, markMutationFailure, removeMutation } from "./mutationQueue";

const activeSyncs = new Set();

export const runMutationSync = async ({
  key,
  entityTypes,
  includeFailed = false,
  execute,
  onSuccess,
}) => {
  if (!canSyncNow() || activeSyncs.has(key)) return { synced: 0, pending: 0 };
  activeSyncs.add(key);
  let synced = 0;
  const processed = new Set();
  try {
    let pending = 0;
    while (true) {
      const listed = await listMutations({ entityTypes, includeFailed });
      const entries = (listed || []).filter((entry) =>
        entry.metadata?.localOnly !== true &&
        !processed.has(`${entry.entityType}:${entry.id}`));
      pending = entries.length;
      if (!entries.length) break;
      let failed = false;
      for (const mutation of entries) {
        try {
          const result = await execute(mutation, entries);
          await onSuccess?.(mutation, result, entries);
          await removeMutation(mutation);
          processed.add(`${mutation.entityType}:${mutation.id}`);
          synced += 1;
        } catch (error) {
          await markMutationFailure(mutation, error, error?.permanent === true);
          failed = true;
          break;
        }
      }
      if (failed) break;
    }
    return { synced, pending: Math.max(0, pending) };
  } finally {
    activeSyncs.delete(key);
  }
};
